module.exports = __webpack_public_path__ + "src/images/measurements/highBust.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/highBust.jpg
// module id = 600
// module chunks = 0